import { Box, Tooltip } from "@chakra-ui/react";
import { BESZLA_JOVAHAGY_META, BESZLA_PUB_META } from "@coimbra-its/api.konyvelo";
import { CellProps, formatMoney1, TableMeta, useWSysLayoutContext, useWSysMainTable, useWSysPage, useWSysPath, WSysPage, WSysSearch, WSysTable, WSysVert } from "@coimbra-its/websys-ux-core";
import { useKonyveloApi } from "../store/konyvelo.api";
import { Beszla } from "./Beszla";
import { PushNotificationButton } from "../components/PushNotificationButton";
import { WSysTableSettings } from "../temp/TableSettings";

const CELLS = new TableMeta(BESZLA_JOVAHAGY_META)
	.Delete('DOKID').Delete('DEV')
	.Map2('PREVJOV_DATE', row => <Box>!!!</Box>)
	.Map2('BRUTTO', row => formatMoney1(row.BRUTTO, 'HUF')).Set('BRUTTO', { width: '150px' })
	.Map2('KERET', row => formatMoney1(row.BRUTTO, 'HUF')).Set('KERET', { width: '150px' })
	.Map2('AKT_OSSZEG', row => formatMoney1(row.BRUTTO, 'HUF')).Set('AKT_OSSZEG', { width: '150px' })
	.Set('P_KOD', { charWidth: 10, width: '100px' })
	.Set('P_NEV', { charWidth: 40, width: '350px' })
	.Map2('P_NEV', row => <>
		{row.PREVJOV_DATE && <Tooltip label={row.PREVJOV_MESSAGE} ><Box as='span' bgColor='red' color='#fff' p='0 2px' display='inline-block' mr={1} borderRadius='md' >!!!</Box></Tooltip>}{row.P_NEV}
	</>)
	.forTable();



export function BeszlaJovahagyLista() {


	const path = useWSysPath();
	const [q] = path.useParam('q');

	// ---------------------
	const tableProps = useWSysMainTable(path, [q]);


	// ---------------------

	const api = useKonyveloApi();
	const [szamlaGetRes, hub] = api.beszlaJovahagyasGet.useData({ q, ...tableProps.forPath });
	const szamlak = szamlaGetRes?.szamlak?.items || [];
	const szamlaPath = path.useChildRow('', szamlak, szamla => szamla.DOKID);

	const layout = useWSysLayoutContext();
	const page = useWSysPage({ title: 'Számlák jóváhagyása', maxCols: 10 /*szamlaPath.isOpen ? (Math.max(layout.widthCols - 4, 2)) : 10 */ });


	return <WSysPage page={page} hubs={[hub]}

		tools={<Box display='flex' gap={2}>
			<WSysSearch name='q' />
			<PushNotificationButton subject={'beszla_jovahagy'} />
			<WSysTableSettings orderBy={tableProps.forTable.orderBy} orderByChanged={tableProps.forTable.orderByChanged} cells={CELLS} reset={{ orderBy: '', title: 'Alaphelyzet (ID desc)' }} />
		</Box>}

	>
		<WSysVert mode="rest">
			<WSysTable
				cells={CELLS}
				rows={szamlak}
				tableInfo={szamlaGetRes?.szamlak.info}
				{...szamlaPath.forTable}
				//onRowSelect={e => alert(e.DOKID)}
				{...tableProps.forTable}
				mode={3}
				noHead={layout.isMobileFull || true}

			/>
		</WSysVert>

		{/*szamlaPath.on(szamlaPath.forTable.selectedRow && <Beszla DOKID={szamlaPath.forTable.selectedRow.DOKID}  />)*/}
		{szamlaPath.on(szamlaPath.forTable.selectedRow && <Beszla tipus="dokid" oszlaID_or_DokId={szamlaPath.forTable.selectedRow.DOKID} showJovahagyas={true} />)}
	</WSysPage>
}